export enum TyrePositionEnum {
  NSF = 1, // Near Side Front
  OSF = 2, // Off Side Front
  NSR = 3, // Near Side Rear
  OSR = 4, // Off Side Rear
  SPARE = 5 // Spare Tyre
}
